import { NativeModules, Platform } from 'react-native';

const LINKING_ERROR =
  `The package 'react-native-polls' doesn't seem to be linked. Make sure: \n\n` +
  Platform.select({ ios: "- You have run 'pod install'\n", default: '' }) +
  '- You rebuilt the app after installing the package\n' +
  '- You are not using Expo managed workflow\n';

NativeModules.Polls
  ? NativeModules.Polls
  : new Proxy(
      {},
      {
        get() {
          throw new Error(LINKING_ERROR);
        },
      }
    );

// function multiply(a: number, b: number): Promise<number> {
//   return Polls.multiply(a, b);
// }

export * from '@polls-platform/core';
export * from './components';
